import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { ErrorBoundary } from '../../../../errorHandling/ErrorBoundary';
import { LogoDataProps } from '../header/Logo';
import { NavigationLink } from '../oldHeader/primaryHeader/PrimaryHeader';
import { MenuData } from '../header/RowWithFixedNav';
import { FirstRowHeader } from './FirstRowHeader';
import { ThirdRowHeader } from './ThirdRowHeader';
import { SecondRowHeader } from './SecondRowHeader';
import { useThemeOverride } from '../../../../../theming/useThemeOverride';
import { HeaderThemeProps, componentConfigThemeKey } from '../Header.theme';
import { ThemeContext } from '../../../../../theming/ThemeProviderWithFonts';

export interface SubHeader {
  logoForLargeScreen: LogoDataProps | null;
  links: NavigationLink[] | null;
  megaMenu: NavigationLink[] | null;
}

export interface ThirdHeader {
  links: NavigationLink[];
  feedName: string;
}

export interface Subscribe {
  linkText: string;
  url: string;
}
export interface ThreeRowsHeaderProps {
  links: NavigationLink[];
  menu: MenuData | null;
  subHeader: SubHeader | null;
  showAccessibilityIcon?: boolean;
  subscribeLink?: Subscribe;
  thirdHeader: ThirdHeader | null;
}

const getHeaderStyles = () => {
  return StyleSheet.create({
    style: {
      width: '100%',
      zIndex: 1500,
      top: 0,
    },
  });
};

export const ThreeRowsHeader: React.FunctionComponent<ThreeRowsHeaderProps> = props => {
  const { links, subscribeLink, subHeader, menu, showAccessibilityIcon, thirdHeader } = props;
  const headerStyle = getHeaderStyles();

  const themeContextMenu = useThemeOverride<HeaderThemeProps>({
    firstRowHeightInLargeScreen: 3.9,
    firstRowHeightInMediumScreen: 4.4,
    firstRowHeightInSmallScreen: 4.4,
  }, componentConfigThemeKey);

  return (
    <ErrorBoundary>
      <ThemeContext.Provider value={themeContextMenu}>
        <header className={css(headerStyle.style)}>
          {links && <FirstRowHeader links={links} subscribeLink={subscribeLink} />}
          {subHeader && <SecondRowHeader subHeader={subHeader} menu={menu} showAccessibilityIcon={showAccessibilityIcon} feedName={thirdHeader?.feedName} />}
          {thirdHeader && <ThirdRowHeader links={thirdHeader.links} name={thirdHeader.feedName} />}
        </header>
      </ThemeContext.Provider>

    </ErrorBoundary>
  );
};
